import { Modal, Result } from '@bfe/moly';
import { useLocale } from '../../store/i18nMessage';
import { getDefaultIndex } from '../../store/config';
export type Web3LawAlertModalProps = {
  visible: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
};

export function Web3LawAlertModal({ visible, onConfirm, onCancel }: Web3LawAlertModalProps) {
  const { t } = useLocale();
  return (
    <Modal modal={false} zIndex={getDefaultIndex()} open={visible} okText={t('next')} onOk={onConfirm} onCancel={onCancel} closable={false}>
      <Result status="warning" title={t('serviceReminder')} className="!pb-2"></Result>
      <p className=" mb-12 text-sm text-bds-gray-t2 text-center">{t('nlContractualClaim')}</p>
    </Modal>
  );
}
